import React, { Fragment, useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import LoaderSpinner from "../../common/LoaderSpinner";
import { getStudentProfile } from "../../api/admissionApi";
import RegistrationFormPreview from "./RegistrationFormPreview";
import FeeReceiptPreview from "./RegistrationFormPreview";
import moment from "moment";
import { processHtmlToPdf } from "../../common/HtmlToPdf";

function DownloadDocuments() {
  // this component is for : registration form, admit card, fee receipt (if online payment)
  useEffect(() => {
    getStudProfile(email_id, {
      successCallback: getStudentProfileSuccessCallback,
      failureCallback: () => {
        setIsDocumentAvailable(false);
        toast.error("Couldn't find your registration form, try again!");
      },
    });
  }, []);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const {
    authenticationReducer: {
      studentProfile: { is_registration_completed, email_id },
    } = {},
    admissionReducer: { isUserProfileLoading = false } = {},
  } = state || {};
  const getStudProfile = (email, cbs) =>
    dispatch(getStudentProfile(email, cbs));
  const htmlToPdfRef = useRef(null);
  const [isDocumentAvailable, setIsDocumentAvailable] = useState(false);
  const [activePreviewDoc, setActivePreviewDoc] = useState({});
  const [selectedDoc, setSelectedDoc] = useState("");

  const [regFormData, setRegFormData] = useState({});
  const [feeReceiptData, setFeeReceiptData] = useState({});

  const [activeDocNodeId, setActiveDocNodeId] = useState("");

  const fetchDocument = (selectedDocument) => {
    setActivePreviewDoc({});
    setSelectedDoc(selectedDocument);
  };
  const getStudentProfileSuccessCallback = (response) => {
    setIsDocumentAvailable(true);
    setRegFormData(response.profileDetails);
  };

  const actionButtonHandler = (val) => {
    if (val === "preview") {
      if (selectedDoc === "form") {
        setActivePreviewDoc(regFormData);
      } else if (selectedDoc === "fee") {
        setActivePreviewDoc(feeReceiptData);
      }
    } else if (val === "download") {
      if (selectedDoc === "form") {
        processHtmlToPdf({
          nodeId: `${activeDocNodeId}`,
          header: "St. Andrews College",
          title: `Pre-Registration UG/PG Entrance Examination Form ${new Date().getFullYear()} - ${
            new Date().getFullYear() + 1
          } (Online generated copy)`,
          footer: `*Document generated on : ${moment(new Date()).format(
            "DD-MMM-YYYY: hh:mm A"
          )}`,
          filename: `${
            regFormData.full_name.first_name
          } (Registration form) ${new Date().getFullYear()} - ${
            new Date().getFullYear() + 1
          }`,
          orientation: "p",
          pageType: 'table'
        });
      } else if (selectedDoc === "fee") {
      }
    }
  };

  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Download documents</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <span>St. Andrews College</span>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Download documents
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderContent = () => {
    return (
      <div className="card">
        <div className="card-body">
          <div className="card-header pl-0 pt-0 justify-content-between">
            <h3 className="card-title">
              Download all your documents from one place
            </h3>
            {isUserProfileLoading && (
              <div>
                <span className="mr-2">Fetching Profile</span>
                <LoaderSpinner />
              </div>
            )}
          </div>
          {(!is_registration_completed && !isUserProfileLoading) && (
            <div style={{ color: "red" }}>
              *Documents can be downloaded only after registration form
              submission
            </div>
          )}
          <div className="mt-3">
            <div className="form-group d-flex align-items-center">
              <FormControl sx={{ width: 250 }} size="small">
                <InputLabel id="demo-simple-select-label">
                  Select Document Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Select Document Type"
                  onChange={(event) => fetchDocument(event.target.value)}
                >
                  <MenuItem value="form">Registration Form</MenuItem>
                  <MenuItem value="collegeFee">Course Fee Reciept</MenuItem>
                  <MenuItem value="admissionCard">Admission card</MenuItem>
                  <MenuItem value="courseFee">College Fee Reciept</MenuItem>

                </Select>
              </FormControl>
              <div className="ml-5">
                <button
                  value="download"
                  type="button"
                  className="btn btn-primary"
                  disabled={!is_registration_completed || !isDocumentAvailable || !selectedDoc || isUserProfileLoading}
                  onClick={(e) => actionButtonHandler(e.target.value)}
                >
                  Download
                </button>
                <button
                  value="preview"
                  type="button"
                  className="btn btn-primary ml-2"
                  disabled={!is_registration_completed || !isDocumentAvailable || !selectedDoc || isUserProfileLoading}
                  onClick={(e) => actionButtonHandler(e.target.value)}
                >
                  Preview
                </button>
              </div>
            </div>
          </div>
          {Object.keys(activePreviewDoc).length > 0 &&
            isDocumentAvailable &&
            selectedDoc === "form" && (
              <RegistrationFormPreview
                valObj={activePreviewDoc}
                setActiveDocNodeId={setActiveDocNodeId}
              />
            )}
          {Object.keys(activePreviewDoc).length > 0 &&
            isDocumentAvailable &&
            selectedDoc === "fee" && (
              <FeeReceiptPreview
                valObj={activePreviewDoc}
                setActiveDocNodeId={setActiveDocNodeId}
              />
            )}
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}

export default DownloadDocuments;
